import http from "@/utils/http";
const prefixUrl = {
  daily: "/Index/detail5day.html", // API-4
};
export default {
  query(params = {}) {
    return http.get(prefixUrl.daily, { params });
  },
};
